import React, { useState, useEffect } from 'react';
import api from '../../services/api';

function fmtTel(n) {
  if (!n || n.startsWith('lid_')) return '—';
  const d = n.replace(/\D/g,'');
  // 5547988392978 = 55 + 47 + 9 digitos (celular com 9)
  if (d.length === 13) return `+${d.slice(0,2)} (${d.slice(2,4)}) ${d.slice(4,9)}-${d.slice(9,13)}`;
  // 554791943479 = 55 + 47 + 8 digitos (fixo)
  if (d.length === 12) return `+${d.slice(0,2)} (${d.slice(2,4)}) ${d.slice(4,8)}-${d.slice(8,12)}`;
  if (d.length === 11) return `(${d.slice(0,2)}) ${d.slice(2,7)}-${d.slice(7)}`;
  if (d.length === 10) return `(${d.slice(0,2)}) ${d.slice(2,6)}-${d.slice(6)}`;
  return n;
}

function fmtTempo(min) {
  if (!min || min <= 0) return '-';
  if (min < 60) return `${min} min`;
  const h = Math.floor(min/60), m = Math.round(min%60);
  return m > 0 ? `${h}h ${m}min` : `${h}h`;
}

function fmtData(d) {
  if (!d) return '-';
  return new Date(d).toLocaleDateString('pt-BR', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' });
}

export default function Clientes() {
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busca, setBusca] = useState('');
  const [ordem, setOrdem] = useState('ultimo_contato');

  useEffect(() => {
    api.get('/clientes').then(({ data }) => setClientes(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const filtrados = clientes
    .filter(c => {
      const q = busca.toLowerCase();
      return !q || (c.nome_whatsapp||'').toLowerCase().includes(q) || (c.numero_whatsapp||'').includes(q);
    })
    .sort((a, b) => {
      if (ordem === 'nome') return (a.nome_whatsapp||'').localeCompare(b.nome_whatsapp||'');
      if (ordem === 'total') return (b.total_atendimentos||0) - (a.total_atendimentos||0);
      if (ordem === 'tempo_medio') return (b.tempo_medio_minutos||0) - (a.tempo_medio_minutos||0);
      return new Date(b.ultimo_contato||0) - new Date(a.ultimo_contato||0);
    });

  return (
    <div style={{padding:24, maxWidth:1100, margin:'0 auto', height:'100%', overflowY:'auto', boxSizing:'border-box'}}>
      <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20}}>
        <div>
          <h2 style={{margin:0, fontSize:20, fontWeight:700}}>👥 Clientes</h2>
          <p style={{margin:'4px 0 0', color:'var(--text-muted)', fontSize:13}}>{clientes.length} clientes cadastrados</p>
        </div>
        <div style={{display:'flex', gap:8}}>
          <input value={busca} onChange={e => setBusca(e.target.value)}
            placeholder="🔍 Buscar por nome ou telefone..."
            style={{padding:'8px 12px', borderRadius:8, border:'1px solid var(--border)', background:'var(--bg-surface)', color:'var(--text-primary)', fontSize:13, width:260}} />
          <select value={ordem} onChange={e => setOrdem(e.target.value)}
            style={{padding:'8px 12px', borderRadius:8, border:'1px solid var(--border)', background:'var(--bg-surface)', color:'var(--text-primary)', fontSize:13}}>
            <option value="ultimo_contato">Último contato</option>
            <option value="nome">Nome A-Z</option>
            <option value="total">Mais atendimentos</option>
            <option value="tempo_medio">Maior tempo médio</option>
          </select>
        </div>
      </div>

      {loading ? (
        <div style={{textAlign:'center', padding:60, color:'var(--text-muted)'}}>Carregando...</div>
      ) : filtrados.length === 0 ? (
        <div style={{textAlign:'center', padding:60, color:'var(--text-muted)'}}>Nenhum cliente encontrado</div>
      ) : (
        <div style={{background:'var(--bg-surface)', borderRadius:12, border:'1px solid var(--border)', overflow:'hidden'}}>
          <table style={{width:'100%', borderCollapse:'collapse', fontSize:13}}>
            <thead>
              <tr style={{background:'var(--bg-elevated)', borderBottom:'1px solid var(--border)'}}>
                <th style={{padding:'10px 16px', textAlign:'left', color:'var(--text-muted)', fontWeight:600}}>Nome</th>
                <th style={{padding:'10px 16px', textAlign:'left', color:'var(--text-muted)', fontWeight:600}}>Telefone</th>
                <th style={{padding:'10px 16px', textAlign:'center', color:'var(--text-muted)', fontWeight:600}}>Atendimentos</th>
                <th style={{padding:'10px 16px', textAlign:'center', color:'var(--text-muted)', fontWeight:600}}>Tempo médio</th>
                <th style={{padding:'10px 16px', textAlign:'center', color:'var(--text-muted)', fontWeight:600}}>Tempo total</th>
                <th style={{padding:'10px 16px', textAlign:'left', color:'var(--text-muted)', fontWeight:600}}>Último contato</th>
              </tr>
            </thead>
            <tbody>
              {filtrados.map((c, i) => (
                <tr key={c.id} style={{borderBottom:'1px solid var(--border)', background: i%2===0 ? 'transparent' : 'var(--bg-elevated)'}}>
                  <td style={{padding:'10px 16px'}}>
                    <div style={{display:'flex', alignItems:'center', gap:8}}>
                      <div style={{width:32, height:32, borderRadius:'50%', background:'var(--tema-cor)', display:'flex', alignItems:'center', justifyContent:'center', color:'white', fontWeight:700, fontSize:12, flexShrink:0}}>
                        {(c.nome_whatsapp||'?').slice(0,2).toUpperCase()}
                      </div>
                      <span style={{fontWeight:500}}>{c.nome_whatsapp || '—'}</span>
                    </div>
                  </td>
                  <td style={{padding:'10px 16px', color:'var(--text-muted)'}}>{fmtTel(c.numero_whatsapp)}</td>
                  <td style={{padding:'10px 16px', textAlign:'center'}}>
                    <span style={{background:'var(--tema-cor)22', color:'var(--tema-cor)', borderRadius:12, padding:'2px 10px', fontWeight:600}}>
                      {c.total_atendimentos || 0}
                    </span>
                  </td>
                  <td style={{padding:'10px 16px', textAlign:'center', color:'var(--text-muted)'}}>{fmtTempo(c.tempo_medio_minutos)}</td>
                  <td style={{padding:'10px 16px', textAlign:'center', color:'var(--text-muted)'}}>{fmtTempo(c.tempo_total_minutos)}</td>
                  <td style={{padding:'10px 16px', color:'var(--text-muted)', fontSize:12}}>{fmtData(c.ultimo_contato)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
